import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Agreement from "@/components/Agreement";
// import Privacy from "@/components/Privacy";
import Success from "@/components/Success";
import CustomerService from '@/views/customerService/index.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/agreement",
      name: "Agreement",
      component: Agreement
    },
    // {
    //   path: "/privacy",
    //   name: "Privacy",
    //   component: Privacy
    // },
    {
      path: "/success",
      name: "Success",
      component: Success
    },{
      path:'/customerService',
      name:'CustomerService',
      meta:{title:'凡商云购客服'},
      component:CustomerService
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js